export class FeatureManager {
    private editorCanvasComponent: any;
    private defaultFeatureName: string;
    private activeFeature: any;
    private features: any;

    constructor(editorCanvasComponent, defaultFeatureName) {
        this.editorCanvasComponent = editorCanvasComponent;
        this.activeFeature = null;
        this.defaultFeatureName = defaultFeatureName;
        this.features = {};
    }

    registerFeature(name, tool) {
        this.features[name] = { tool };
    }

    activateFeature(name) {
        if (this.activeFeature) {
            this.activeFeature.deactivate();
            this.activeFeature = null;
        }

        if (name && this.features[name]) {
            const { tool } = this.features[name];
            this.activeFeature = tool;
            this.activeFeature.activate(this.editorCanvasComponent);
        } else if (this.defaultFeatureName && this.features[this.defaultFeatureName]) {
            const { tool } = this.features[this.defaultFeatureName];
            this.activeFeature = tool;
            this.activeFeature.activate(this.editorCanvasComponent);
        }
    }
}